import { StatusEnum } from "../../hoc/with-status";
import { BGCInformationProps } from "./types";
import { FlyOutStatusCard, bgcUseStatusText } from "../utilities/FlyOutStatusCard";
import React from "react";
import ProgressRing from "../screening-results/progress-ring.svg";
import { IconCheckCircleFill, IconCloseCircleFill, IconSize } from "@amzn/stencil-react-components/icons";
import { HVH_COLORS } from "../../config/palette";

export const BGCInformation = ({ status }: BGCInformationProps) => {
  if (status == StatusEnum.AWAITING_CANDIDATE_INFO) {
    return (
      <FlyOutStatusCard
        status={status}
        image={<img width={"24px"} height={"24px"} src={ProgressRing} alt="" />}
        descriptionText={bgcUseStatusText(status)}
      />
    );
  }

  if (status == StatusEnum.COMPLETED) {
    return (
      <FlyOutStatusCard
        status={status}
        image={<IconCheckCircleFill size={IconSize.Medium} color={HVH_COLORS.GREEN_70} />}
        descriptionText={bgcUseStatusText(status)}
      />
    );
  }

  if (status == StatusEnum.ERROR) {
    return (
      <FlyOutStatusCard
        status={status}
        image={<IconCloseCircleFill size={IconSize.Medium} color={HVH_COLORS.RED_70} />}
        descriptionText={bgcUseStatusText(status)}
      />
    );
  }

  return (
    <FlyOutStatusCard
      status={status}
      image={<img width={"24px"} height={"24px"} src={ProgressRing} alt="" />}
      descriptionText={bgcUseStatusText(status)}
    />
  );
};
